import { render } from "./SnapAndSendSubmission.vue?vue&type=template&id=a9055652&scoped=true"
import script from "./SnapAndSendSubmission.vue?vue&type=script&lang=js"
export * from "./SnapAndSendSubmission.vue?vue&type=script&lang=js"

import "./SnapAndSendSubmission.vue?vue&type=style&index=0&id=a9055652&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9055652"]])

export default __exports__